// src/components/SessionExpiredBanner.tsx
// UI: shadcn AlertDialog with a single "Refresh" action.
// Mounted once (e.g., in App.tsx) so it's always available.
import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { subscribeSessionExpired, wasSessionExpiredNotified } from "@/lib/session/sessionExpired";

export function SessionExpiredBanner() {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState<boolean>(wasSessionExpiredNotified());

  React.useEffect(() => {
    return subscribeSessionExpired(() => setOpen(true));
  }, []);

  if (!open) return null;

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("session.expired_title", "Session expired")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("session.expired_description", "Your authentication session is no longer valid. Please refresh the page to log in again.")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction asChild>
            <a href="https://id.boona.app/login">
              {t("session.login_again", "Log in")}
            </a>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
